import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import DocumentTitle from 'react-document-title'
import PropTypes from 'prop-types'

import { InvoicesFilterPanel, InvoicesView } from '../Components'

class DraftedInvoicesReport extends Component {
  static propTypes = {
    draftedInvoicesStore: PropTypes.object
  }

  render () {
    return (
      <DocumentTitle title='Drafted invoices | Atheneum Partners'>
        <div className='expert-search'>
          <InvoicesFilterPanel
            invoicesStore={this.props.draftedInvoicesStore}
          />
          <InvoicesView
            title='Drafted invoices'
            invoicesStore={this.props.draftedInvoicesStore}
          />
        </div>
      </DocumentTitle>
    )
  }
}

export default inject('draftedInvoicesStore')(observer(DraftedInvoicesReport))
